export const INVENTORY_TX_TYPE_OPTIONS = [
  { value: '', label: 'Todos os tipos' },
  { value: 'restock', label: 'Reposição' },
  { value: 'manual_adjust', label: 'Ajuste manual' },
  { value: 'open', label: 'Abertura' },
  { value: 'deplete', label: 'Esgotamento' },
  { value: 'appointment_usage', label: 'Uso em atendimento' },
  { value: 'appointment_reversal', label: 'Reversão de atendimento' },
];

const TYPE_LABELS = {
  restock: 'Reposição',
  manual_adjust: 'Ajuste manual',
  open: 'Abertura',
  deplete: 'Esgotamento',
  appointment_usage: 'Uso em atendimento',
  appointment_reversal: 'Reversão de atendimento',
};

/**
 * @param {string|null|undefined} type
 * @returns {string}
 */
export function inventoryTransactionTypeLabel(type) {
  return TYPE_LABELS[type] || type || 'Movimentação';
}

/**
 * @param {*} createdAt Firestore Timestamp or date-like value
 * @returns {string}
 */
export function formatInventoryTransactionWhen(createdAt) {
  if (!createdAt) return '—';
  const date = typeof createdAt.toDate === 'function' ? createdAt.toDate() : new Date(createdAt);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' });
}

/**
 * @param {object} tx
 * @param {object|null|undefined} supply
 * @returns {string}
 */
export function formatInventoryTransactionDelta(tx, supply) {
  const unit = supply?.unitPlural || supply?.unit || 'un';

  if (tx.quantityDelta != null && tx.quantityDelta !== '') {
    const delta = Number(tx.quantityDelta);
    if (!Number.isFinite(delta) || delta === 0) {
      if (tx.type === 'appointment_usage' && tx.note === 'container_reference') {
        return 'Utilizado';
      }
      return '—';
    }
    const sign = delta > 0 ? '+' : '';
    return `${sign}${delta} ${unit}`;
  }

  if (tx.sealedDelta != null && tx.sealedDelta !== '') {
    const delta = Number(tx.sealedDelta);
    if (!Number.isFinite(delta) || delta === 0) return '—';
    const sign = delta > 0 ? '+' : '';
    const sealedUnit = Math.abs(delta) === 1
      ? (supply?.unit || 'unidade')
      : (supply?.unitPlural || supply?.unit || 'unidades');
    return `${sign}${delta} ${sealedUnit} fechado(s)`;
  }

  if (tx.type === 'open' || tx.type === 'deplete') {
    const singleUnit = supply?.unit || 'unidade';
    return tx.type === 'open' ? `−1 ${singleUnit} fechado` : `1 ${singleUnit} esgotado`;
  }

  if (tx.type === 'appointment_usage') {
    return tx.note === 'container_reference' ? 'Utilizado' : '—';
  }

  return '—';
}

/**
 * @param {object} tx
 * @returns {string|null}
 */
export function inventoryTransactionDetail(tx) {
  const parts = [];
  if (tx.note && tx.note !== 'container_reference') {
    parts.push(tx.note);
  }
  if (tx.appointmentId) {
    parts.push('Atendimento');
  }
  return parts.length ? parts.join(' · ') : null;
}
